const country = [
  { val: 'Afghanistan', num: '004' },
  { val: 'Åland Islands', num: '248' },
  { val: 'Albania', num: '008' },
  { val: 'Algeria', num: '012' },
  { val: 'American Samoa', num: '016' },
  { val: 'Andorra', num: '020' },
  { val: 'Angola', num: '024' },
  { val: 'Anguilla', num: '660' },
  { val: 'Antarctica', num: '010' },
  { val: 'Antigua and Barbuda', num: '028' },
  { val: 'Argentina', num: '032' },
  { val: 'Armenia', num: '051' },
  { val: 'Aruba', num: '533' },
  { val: 'Australia', num: '036' },
  { val: 'Austria', num: '040' },
  { val: 'Azerbaijan', num: '031' },
  { val: 'Bahamas', num: '044' },
  { val: 'Bahrain', num: '048' },
  { val: 'Bangladesh', num: '050' },
  { val: 'Barbados', num: '052' },
  { val: 'Belarus', num: '112' },
  { val: 'Belgium', num: '056' },
  { val: 'Belize', num: '084' },
  { val: 'Benin', num: '204' },
  { val: 'Bermuda', num: '060' },
  { val: 'Bhutan', num: '064' },
  { val: 'Bolivia (Plurinational State of)', num: '068' },
  { val: 'Bonaire, Sint Eustatius and Saba[d]', num: '535' },
  { val: 'Bosnia and Herzegovina', num: '070' },
  { val: 'Botswana', num: '072' },
  { val: 'Bouvet Island', num: '074' },
  { val: 'Brazil', num: '076' },
  { val: 'British Indian Ocean Territory', num: '086' },
  { val: 'Brunei Darussalam', num: '096' },
  { val: 'Bulgaria', num: '100' },
  { val: 'Burkina Faso', num: '854' },
  { val: 'Burundi', num: '108' },
  { val: 'Cabo Verde', num: '132' },
  { val: 'Cambodia', num: '116' },
  { val: 'Cameroon', num: '120' },
  { val: 'Canada', num: '124' },
  { val: 'Cayman Islands', num: '136' },
  { val: 'Central African Republic', num: '140' },
  { val: 'Chad', num: '148' },
  { val: 'Chile', num: '152' },
  { val: 'China', num: '156' },
  { val: 'Christmas Island', num: '162' },
  { val: 'Cocos (Keeling) Islands', num: '166' },
  { val: 'Colombia', num: '170' },
  { val: 'Comoros', num: '174' },
  { val: 'Congo', num: '178' },
  { val: 'Congo, Democratic Republic of the', num: '180' },
  { val: 'Cook Islands', num: '184' },
  { val: 'Costa Rica', num: '188' },
  { val: "Côte d'Ivoire", num: '384' },
  { val: 'Croatia', num: '191' },
  // { val: 'Cuba', num: '192' },
  { val: 'Curaçao', num: '531' },
  { val: 'Cyprus', num: '196' },
  { val: 'Czechia', num: '203' },
  { val: 'Denmark', num: '208' },
  { val: 'Djibouti', num: '262' },
  { val: 'Dominica', num: '212' },
  { val: 'Dominican Republic', num: '214' },
  { val: 'Ecuador', num: '218' },
  { val: 'Egypt', num: '818' },
  { val: 'El Salvador', num: '222' },
  { val: 'Equatorial Guinea', num: '226' },
  { val: 'Eritrea', num: '232' },
  { val: 'Estonia', num: '233' },
  { val: 'Eswatini', num: '748' },
  { val: 'Ethiopia', num: '231' },
  { val: 'Falkland Islands (Malvinas)', num: '238' },
  { val: 'Faroe Islands', num: '234' },
  { val: 'Fiji', num: '242' },
  { val: 'Finland', num: '246' },
  { val: 'France', num: '250' },
  { val: 'French Guiana', num: '254' },
  { val: 'French Polynesia', num: '258' },
  { val: 'French Southern Territories', num: '260' },
  { val: 'Gabon', num: '266' },
  { val: 'Gambia', num: '270' },
  { val: 'Georgia', num: '268' },
  { val: 'Germany', num: '276' },
  { val: 'Ghana', num: '288' },
  { val: 'Gibraltar', num: '292' },
  { val: 'Greece', num: '300' },
  { val: 'Greenland', num: '304' },
  { val: 'Grenada', num: '308' },
  { val: 'Guadeloupe', num: '312' },
  { val: 'Guam', num: '316' },
  { val: 'Guatemala', num: '320' },
  { val: 'Guernsey', num: '831' },
  { val: 'Guinea', num: '324' },
  { val: 'Guinea-Bissau', num: '624' },
  { val: 'Guyana', num: '328' },
  { val: 'Haiti', num: '332' },
  { val: 'Heard Island and McDonald Islands', num: '334' },
  { val: 'Holy See', num: '336' },
  { val: 'Honduras', num: '340' },
  // { val: 'Hong Kong (China)', num: '344' },
  { val: 'Hungary', num: '348' },
  { val: 'Iceland', num: '352' },
  { val: 'India', num: '356' },
  { val: 'Indonesia', num: '360' },
  { val: 'Iran (Islamic Republic of)', num: '364' },
  { val: 'Iraq', num: '368' },
  { val: 'Ireland', num: '372' },
  { val: 'Isle of Man', num: '833' },
  { val: 'Israel', num: '376' },
  { val: 'Italy', num: '380' },
  { val: 'Jamaica', num: '388' },
  { val: 'Japan', num: '392' },
  { val: 'Jersey', num: '832' },
  { val: 'Jordan', num: '400' },
  { val: 'Kazakhstan', num: '398' },
  { val: 'Kenya', num: '404' },
  { val: 'Kiribati', num: '296' },
  // { val: "Korea (Democratic People's Republic of)", num: '408' },
  { val: 'Korea, Republic of', num: '410' },
  { val: 'Kuwait', num: '414' },
  { val: 'Kyrgyzstan', num: '417' },
  { val: "Lao People's Democratic Republic", num: '418' },
  { val: 'Latvia', num: '428' },
  { val: 'Lebanon', num: '422' },
  { val: 'Lesotho', num: '426' },
  { val: 'Liberia', num: '430' },
  { val: 'Libya', num: '434' },
  { val: 'Liechtenstein', num: '438' },
  { val: 'Lithuania', num: '440' },
  { val: 'Luxembourg', num: '442' },
  // { val: 'Macao (China)', num: '446' },
  { val: 'Madagascar', num: '450' },
  { val: 'Malawi', num: '454' },
  { val: 'Malaysia', num: '458' },
  { val: 'Maldives', num: '462' },
  { val: 'Mali', num: '466' },
  { val: 'Malta', num: '470' },
  { val: 'Marshall Islands', num: '584' },
  { val: 'Martinique', num: '474' },
  { val: 'Mauritania', num: '478' },
  { val: 'Mauritius', num: '480' },
  { val: 'Mayotte', num: '175' },
  { val: 'Mexico', num: '484' },
  { val: 'Micronesia (Federated States of)', num: '583' },
  { val: 'Moldova, Republic of', num: '498' },
  { val: 'Monaco', num: '492' },
  { val: 'Mongolia', num: '496' },
  { val: 'Montenegro', num: '499' },
  { val: 'Montserrat', num: '500' },
  { val: 'Morocco', num: '504' },
  { val: 'Mozambique', num: '508' },
  { val: 'Myanmar', num: '104' },
  { val: 'Namibia', num: '516' },
  { val: 'Nauru', num: '520' },
  { val: 'Nepal', num: '524' },
  { val: 'Netherlands', num: '528' },
  { val: 'New Caledonia', num: '540' },
  { val: 'New Zealand', num: '554' },
  { val: 'Nicaragua', num: '558' },
  { val: 'Niger', num: '562' },
  { val: 'Nigeria', num: '566' },
  { val: 'Niue', num: '570' },
  { val: 'Norfolk Island', num: '574' },
  { val: 'North Macedonia', num: '807' },
  { val: 'Northern Mariana Islands', num: '580' },
  { val: 'Norway', num: '578' },
  { val: 'Oman', num: '512' },
  { val: 'Pakistan', num: '586' },
  { val: 'Palau', num: '585' },
  { val: 'Palestine, State of', num: '275' },
  { val: 'Panama', num: '591' },
  { val: 'Papua New Guinea', num: '598' },
  { val: 'Paraguay', num: '600' },
  { val: 'Peru', num: '604' },
  { val: 'Philippines', num: '608' },
  { val: 'Pitcairn', num: '612' },
  { val: 'Poland', num: '616' },
  { val: 'Portugal', num: '620' },
  { val: 'Puerto Rico', num: '630' },
  { val: 'Qatar', num: '634' },
  { val: 'Réunion', num: '638' },
  { val: 'Romania', num: '642' },
  { val: 'Russian Federation', num: '643' },
  { val: 'Rwanda', num: '646' },
  { val: 'Saint Barthélemy', num: '652' },
  { val: 'Saint Helena, Ascension and Tristan da Cunha[e]', num: '654' },
  { val: 'Saint Kitts and Nevis', num: '659' },
  { val: 'Saint Lucia', num: '662' },
  { val: 'Saint Martin (French part)', num: '663' },
  { val: 'Saint Pierre and Miquelon', num: '666' },
  { val: 'Saint Vincent and the Grenadines', num: '670' },
  { val: 'Samoa', num: '882' },
  { val: 'San Marino', num: '674' },
  { val: 'Sao Tome and Principe', num: '678' },
  { val: 'Saudi Arabia', num: '682' },
  { val: 'Senegal', num: '686' },
  { val: 'Serbia', num: '688' },
  { val: 'Seychelles', num: '690' },
  { val: 'Sierra Leone', num: '694' },
  { val: 'Singapore', num: '702' },
  { val: 'Sint Maarten (Dutch part)', num: '534' },
  { val: 'Slovakia', num: '703' },
  { val: 'Slovenia', num: '705' },
  { val: 'Solomon Islands', num: '090' },
  { val: 'Somalia', num: '706' },
  { val: 'South Africa', num: '710' },
  { val: 'South Georgia and the South Sandwich Islands', num: '239' },
  { val: 'South Sudan', num: '728' },
  { val: 'Spain', num: '724' },
  { val: 'Sri Lanka', num: '144' },
  { val: 'Sudan', num: '729' },
  { val: 'Suriname', num: '740' },
  { val: 'Svalbard and Jan Mayen[f]', num: '744' },
  { val: 'Sweden', num: '752' },
  { val: 'Switzerland', num: '756' },
  // { val: 'Syrian Arab Republic', num: '760' },
  // { val: 'Taiwan, Province of China', num: '158' },
  { val: 'Tajikistan', num: '762' },
  { val: 'Tanzania, United Republic of', num: '834' },
  { val: 'Thailand', num: '764' },
  { val: 'Timor-Leste', num: '626' },
  { val: 'Togo', num: '768' },
  { val: 'Tokelau', num: '772' },
  { val: 'Tonga', num: '776' },
  { val: 'Trinidad and Tobago', num: '780' },
  { val: 'Tunisia', num: '788' },
  { val: 'Turkey', num: '792' },
  { val: 'Turkmenistan', num: '795' },
  { val: 'Turks and Caicos Islands', num: '796' },
  { val: 'Tuvalu', num: '798' },
  { val: 'Uganda', num: '800' },
  { val: 'Ukraine', num: '804' },
  { val: 'United Arab Emirates', num: '784' },
  { val: 'United Kingdom of Great Britain and Northern Ireland', num: '826' },
  { val: 'United States of America', num: '840' },
  { val: 'United States Minor Outlying Islands[h]', num: '581' },
  { val: 'Uruguay', num: '858' },
  { val: 'Uzbekistan', num: '860' },
  { val: 'Vanuatu', num: '548' },
  { val: 'Venezuela (Bolivarian Republic of)', num: '862' },
  { val: 'Viet Nam', num: '704' },
  { val: 'Virgin Islands (British)', num: '092' },
  { val: 'Virgin Islands (U.S.)', num: '850' },
  { val: 'Wallis and Futuna', num: '876' },
  { val: 'Western Sahara', num: '732' },
  { val: 'Yemen', num: '887' },
  { val: 'Zambia', num: '894' },
  { val: 'Zimbabwe', num: '716' }
]

export default {
  country
}
